export enum DestinyViewType {
  ALL = 'All',
  LIBRARY = 'Library',
  RESOURCE = 'Resource',
  TEXTBOOK = 'Textbook'
}
export interface DestinyViewTypeVO {
  viewTypes: DestinyViewType[];
  selectedViewType: DestinyViewType;
}
